export const fillInputValue = ({ drawerData, index, values, readOnly }) => {
  if (drawerData.length > 0 && drawerData[index]) {
    drawerData[index].state = {
      ...drawerData[index].state,
      spinnerValue: values.spinnerValue,
      mainSpinnerInputValue: values.spinnerInputValue,
      subSpinnerValue: values.subSpinnerValue,
      readOnly,
    };
  }
};
